module.exports = __webpack_public_path__ + "static/media/hint.cd25d9bf.ogg";